import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import type { ApiError, UpdateDynamicPricingTenantControlRequest } from '@/shared/api';
import { toApiError, useApi } from '@/shared/api';

export function useDynamicPricingOverview(propertyIds: string[] | null) {
  const api = useApi();
  const queryClient = useQueryClient();
  const [updateError, setUpdateError] = useState<ApiError>();
  const queryKey = ['dynamic-pricing-overview', propertyIds] as const;
  const query = useQuery({
    queryKey,
    queryFn: () => api.dynamicPricingOverview.get(propertyIds),
  });
  const mutation = useMutation({
    mutationFn: (body: UpdateDynamicPricingTenantControlRequest) =>
      api.dynamicPricingOverview.updateTenantControl(body),
    onMutate: () => setUpdateError(undefined),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['dynamic-pricing-overview'] });
    },
    onError: async (error) => {
      setUpdateError(await toApiError(error));
      // Bei einem Konflikt ist der Stand veraltet: neu laden, sonst scheitert jeder weitere Versuch.
      await queryClient.invalidateQueries({ queryKey: ['dynamic-pricing-overview'] });
    },
  });
  return {
    query,
    updateTenantControl: mutation.mutate,
    isUpdating: mutation.isPending,
    updateError,
  };
}
